export const MenuBurguerIconsFavorites = {
    HOME: 'nav_icon_home',
    RESERVA_VEHICULOS_CORTESIA: 'nav_icon_veh_cortesia',
    GESTION_VEHICULOSVC: 'nav_icon_gest_veh',
    PEDIDOS_PIEZAS: 'nav_icon_pedidos_piezas',
    ENTRADAS_ALMACEN: 'nav_icon_entradas_almacen',
    VENTAS_MOSTRADOR: 'nav_icon_venta_mostrador',
    AGENDA_CITAS: 'nav_icon_agenda',
    RECEPCION_VEHICULO: 'nav_icon_recepcion_veh',
    GESTION_OR: 'nav_icon_gest_or',
    PROCESOS_GARANTIA: 'nav_icon_proceso_garantia',
    FACTURACION_OPERACIONES: 'nav_icon_facturacion_oper',
    FACTURACION_MANUAL: 'nav_icon_facturacion_manual',
    INTERFACES_AUTOMATICAS: 'nav_icon_conect_enviosprog',
    MANT_GENERAL: 'nav_icon_mantenimiento',
    INF_GENERAL: 'nav_icon_informes',
    GESTION_TERCEROS: 'nav_icon_gest_client',
    GESTION_VEHICULOS: 'nav_icon_gest_veh',
    HOME_ALMACEN: 'nav_icon_home',
    GESTION_ARTICULOS: 'nav_icon_gest_articulo',
    CORRECCION_STOCK: 'nav_icon_correccion_stock',
    PRESUPUESTOS_VM: 'nav_icon_presup_venta_mostrador',
    BAJA_MASIVA_PIEZAS: 'nav_icon_baja_masiva_almacen',
    INVENTARIO: 'nav_icon_inventario',
    MANT_ALMACEN: 'nav_icon_mantenimiento',
    INF_ALMACEN: 'nav_icon_informes',
    HOME_TALLER: 'nav_icon_home',
    PRESUPUESTOS_TALLER: 'nav_icon_presup_taller',
    BAREMOS_TALLER: 'nav_icon_baremo_rep',
    GARANTIA_SAGAI: 'nav_icon_proceso_garantia',
    MANT_TALLER: 'nav_icon_mantenimiento',
    INF_TALLER: 'nav_icon_informes',
    HOME_FACTURAS: 'nav_icon_home',
    RECIBOS_Y_VENCIMIENTOS: 'nav_icon_facturacion_recibos',
    LIBRETA: 'nav_icon_facturacion_libreta',
    FACTURACION_AGRUPADA: 'nav_icon_facturacion_agrupada',
    FACTURAS_RECIBIDAS: 'nav_icon_facturacion_recibidas',
    FACTURACION_MASIVA_OR: 'nav_icon_facturacion_masiva',
    FACT_REMESAS: 'nav_icon_remesas',
    FACTURAE: 'nav_icon_facturacion_electronica',
    FACT_GESTIONCOBROS: 'nav_icon_control_pagos_fact_cont',
    FACT_GESTIONPAGOS: 'nav_icon_control_pagos_fact_cont',
    TICKETBAI: 'nav_icon_control_pagos_fact_cont',
    AUTOFACTURA: 'nav_icon_facturacion_manual',
    BATUZ: 'nav_icon_control_pagos_fact_cont',
    MANT_FAC: 'nav_icon_mantenimiento',
    INF_FACTURAS: 'nav_icon_informes',
    INTERFACES_MARCA: 'nav_icon_conect_interfacemarca',
    INTERFACES_EXTERNAS: 'nav_icon_conect_apsexternas',
    INTERFACES_ENVIOS_EXTERNOS: 'nav_icon_conect_enviosext',
    INTERFACE_SII: 'nav_icon_conect_enviosext',
    DDC_ACKNOWLEDGE_REPORT: 'nav_icon_conect_enviosext',
    HOME_CONTABILIDAD: 'nav_icon_home',
    CONTABILIDAD_EXPORTACION: 'nav_icon_cont_export',
    CONTABILIDAD_CONFIGURACION: 'nav_icon_cont_config',
    HOME_VO: 'nav_icon_home',
    VEHICULOS_VO: 'nav_icon_vo_gest_veh',
    CLIENTES_VO: 'nav_icon_vo_gest_client',
    RECEPCION_VO: 'nav_icon_vo_nuevoexpediente',
    GESTION_VO: 'nav_icon_vo_gestion',
    VENTA_VO: 'nav_icon_vo_venta',
    MANT_VO: 'nav_icon_mantenimiento',
    INF_VO: 'nav_icon_informes',
    MARKETING: 'nav_icon_marketing',
    GESTION_EMPLEADOS: 'nav_icon_gest_empleados',
    FICHAJES_EMPLEADOS: 'nav_icon_fichaje_empleados',
    GEN_FICHAJESEMP_AUTOMATIC: 'nav_icon_fichaje_empleados',
    MANT_PRODUCTIVIDAD: 'nav_icon_mantenimiento',
    INF_PRODUCTIVIDAD: 'nav_icon_informes'
};

